<template>
  <div class="cascade-selector" :class="classType == 'DeanRecord' ? 'dean_record-cascade-selector' : ''" :style="{ width: isShowInput ?'100%' : 'auto' }">
    <div class="selector-trigger" @click="togglePanel" :style="{ border: isPanelOpen ? '1px solid rgba(24,144,255,0.3)' : '1px solid #D9DAD9' }">
      <div v-if="isShowInput" class="selected-inp">
        <div v-if="!selectedLabels.length" class="selected-ploc">请添加床位</div>
        <div class="selected-tags" v-if="selectedLabels.length">
          <div class="tag" v-for="(label, idx) in selectedLabels" :key="idx">
            {{ label }}
            <i class="tag-close" @click.stop="removeTagOutside(idx)">
              <img src="@/assets/img/CascadeSelector/close-tag.png" alt="">
            </i>
          </div>
        </div>
        <i class="arrow" :class="{ 'up': isPanelOpen }">
          <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTS0xLjA0OTA3ZS0wNiAxLjkwNzM1ZS0wNkwwIDI0TDI0IDI0TDI0IDguNTgyNzVlLTA3TC0xLjA0OTA3ZS0wNiAxLjkwNzM1ZS0wNloiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMDEiLz4KPHBhdGggZD0iTTE2IDEwTDEyIDE0TDggMTAiIHN0cm9rZT0iIzJGMkUzRiIgc3Ryb2tlLW9wYWNpdHk9IjAuNjUiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cgo=" alt="">
        </i>
      </div>
      <div style="width: 100%;" v-else>
        <slot :isPanelOpen="isPanelOpen"></slot>
      </div>
    </div>

    <div class="cascade-panel" v-if="isPanelOpen" @click.stop>
      <div class="panel-content">
        <div
          class="column"
          v-for="(level, levelIndex) in activeLevels"
          :key="levelIndex"
          :style="{ width: columnWidth }"
        >
          <div v-if="levelIndex === 0" class="option all-select">
            <div style="display: flex;">
              <div class="checkbox-img" @click.stop="handleAllCheck">
                <img v-if="isTempAllChecked" :src="checkboxIcons.checked" alt="全选">
                <img v-else-if="isTempAllIndeterminate" :src="checkboxIcons.indeterminate" alt="半选">
                <img v-else :src="checkboxIcons.unchecked" alt="未选">
              </div>
              <span class="labbel-item">全部床位</span>
            </div>
          </div>

          <div
            class="option"
            v-for="item in level"
            :key="item.id"
            @click="handleOptionSelect(item, levelIndex)"
            :class="{ active: item.id == activeNodeIds[levelIndex] }"
          >
            <div class="label-text">
              <div class="checkbox-img" @click.stop="handleOptionCheck(item, levelIndex)">
                <img v-if="isTempOptionChecked(item.id)" :src="checkboxIcons.checked" alt="全选">
                <img v-else-if="isTempOptionIndeterminate(item.id)" :src="checkboxIcons.indeterminate" alt="半选">
                <img v-else :src="checkboxIcons.unchecked" alt="未选">
              </div>
              <label class="labbel-item">{{ item.title }}</label>
            </div>
            <div class="right-arow-its" v-if="item.hasChildren">
              <img style="width:14px; height: 14px;" src="@/assets/img/CascadeSelector/right-arrow.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <button class="btn cancel" @click="closePanel">取消</button>
        <button class="btn confirm" @click="handleConfirm" :style="confirmButtonStyle">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import checkedIcon from '@/assets/img/CascadeSelector/allSel.png';
import indeterminateIcon from '@/assets/img/CascadeSelector/mulSel.png';
import uncheckedIcon from '@/assets/img/CascadeSelector/noSel.png';

export default {
  name: 'CascadeSelector',
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: 'auto'
    },
    columnWidth: {
      type: String,
      default: '150px'
    },
    isShowInput: {
      type: Boolean,
      default: true
    },
    leafRowSelect: {
      type: Boolean,
      default: false
    },
		classType: {
			type: String,
			default: null
    },
    isShowAllCard: {
      type: Boolean,
      default: false
    },
    checkboxIcons: {
      type: Object,
      default: () => ({
        checked: checkedIcon,
        indeterminate: indeterminateIcon,
        unchecked: uncheckedIcon
      })
    },
    confirmButtonStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isPanelOpen: false,
      checkedKeys: [],
      selectedLabels: [],
      tempCheckedKeys: [],
      tempSelectedLabels: [],
      nodeMap: {},
      activeLevels: [],
      activeNodeIds: [],
      totalLeafCount: 0
    }
  },
  computed: {
    tempCheckedLeafIds() {
      return this.tempCheckedKeys.filter(id => {
        const node = this.nodeMap[id];
        return node && !node.hasChildren;
      });
    },
    isTempAllChecked() {
      return this.tempCheckedLeafIds.length == this.totalLeafCount && this.totalLeafCount > 0;
    },
    isTempAllIndeterminate() {
      return this.tempCheckedLeafIds.length > 0 && this.tempCheckedLeafIds.length < this.totalLeafCount;
    },
    checkedLeafIds() {
      return this.checkedKeys.filter(id => {
        const node = this.nodeMap[id];
        return node && !node.hasChildren;
      });
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        if (newData.length > 0) {
          this.buildNodeMap(newData);
          // ========== 修复点 1：等树构建完再初始化默认值 ==========
          if (this.defaultValue&&this.defaultValue.length) {
            this.initFormalCheckedKeys(this.defaultValue);
          }
        }
      }
    },
    // 移除 defaultValue 自动监听，避免时序错乱
    // defaultValue: { ... } 已删除
    tempCheckedKeys: {
      handler() {
        this.updateTempSelectedLabels();
        this.$forceUpdate();
      }
    },
    isPanelOpen: {
      handler(val) {
        if (val) {
          this.initOpenState();
        } else {
          this.resetCloseState();
        }
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    buildNodeMap(treeData) {
      this.nodeMap = {};
      this.totalLeafCount = 0;
      const traverse = (nodes, parentId = null) => {
        nodes.forEach(node => {
          node.parentId = parentId;
          this.nodeMap[node.id] = node;
          if (!node.children || node.children.length === 0) {
            node.hasChildren = false;
            this.totalLeafCount++;
          } else {
            node.hasChildren = true;
            traverse(node.children, node.id);
          }
        });
      };
      traverse(treeData);
    },

    initFormalCheckedKeys(ids) {
      if (!ids || !ids.length || !Object.keys(this.nodeMap).length) return;
      
      this.checkedKeys = [];
      const leafIds = ids.filter(id => {
        const node = this.nodeMap[id];
        return node && !node.hasChildren;
      });

      leafIds.forEach(id => {
        if (!this.checkedKeys.includes(id)) {
          this.checkedKeys.push(id);
          this.updateFormalParentStatus(this.nodeMap[id].parentId);
        }
      });
      this.updateFormalSelectedLabels();
    },

    initOpenState() {
      this.tempCheckedKeys = [...this.checkedKeys];
      if (this.isShowAllCard && this.data.length) {
        this.activeLevels = [];
        this.activeNodeIds = [];
        let currentLevel = this.data;
        while (true) {
          this.activeLevels.push(currentLevel);
          const firstHasChild = currentLevel.find(item => item.children&&item.children.length > 0);
          if (!firstHasChild) break;
          this.activeNodeIds.push(firstHasChild.id);
          currentLevel = firstHasChild.children;
        }
      } else {
        this.activeLevels = [this.data];
        this.activeNodeIds = [];
      }
    },

    resetCloseState() {
      this.activeLevels = [this.data];
      this.activeNodeIds = [];
    },

    isTempOptionChecked(id) {
      return this.tempCheckedKeys.includes(id);
    },

    isTempOptionIndeterminate(id) {
      const node = this.nodeMap[id];
      if (!node || !node.hasChildren) return false;
      const allChecked = node.children.every(child => this.isTempOptionChecked(child.id));
      const anyChecked = node.children.some(child => this.isTempOptionChecked(child.id) || this.isTempOptionIndeterminate(child.id));
      return !allChecked && anyChecked;
    },

    updateTempSelectedLabels() {
      this.tempSelectedLabels = this.tempCheckedLeafIds.map(id => {
				return this.getFullLabelPath(id);
			}).filter(Boolean);
    },

    checkTempNodeRecursive(nodeId) {
      const node = this.nodeMap[nodeId];
      if (!node) return;
      if (!this.isTempOptionChecked(nodeId)) {
        this.tempCheckedKeys.push(nodeId);
      }
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => this.checkTempNodeRecursive(child.id));
      }
    },

    checkTempNodeAndAncestors(nodeId) {
      const node = this.nodeMap[nodeId];
      if (!node) return;
      if (!this.isTempOptionChecked(nodeId)) {
        this.tempCheckedKeys.push(nodeId);
      }
      if (node.parentId) {
        this.checkTempNodeAndAncestors(node.parentId);
      }
    },

    uncheckTempNodeRecursive(nodeId) {
      const node = this.nodeMap[nodeId];
      if (!node) return;
      const index = this.tempCheckedKeys.indexOf(nodeId);
      if (index > -1) {
        this.tempCheckedKeys.splice(index, 1);
      }
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => this.uncheckTempNodeRecursive(child.id));
      }
    },

    handleOptionCheck(item, levelIndex) {
      const isChecked = this.isTempOptionChecked(item.id);
      if (isChecked) {
        this.uncheckTempNodeRecursive(item.id);
      } else {
        this.checkTempNodeRecursive(item.id);
        if (this.isShowAllCard) {
          this.activeNodeIds.splice(levelIndex);
          this.activeNodeIds.push(item.id);
          this.activeLevels.splice(levelIndex + 1);
          let curr = item;
          while (true) {
            if (!curr.children || curr.children.length === 0) break;
            this.activeLevels.push(curr.children);
            const next = curr.children.find(c => c.children&&c.children.length > 0);
            if (!next) break;
            this.activeNodeIds.push(next.id);
            curr = next;
          }
        }
      }
      if (item.parentId) {
        this.updateTempParentStatus(item.parentId);
      }
    },

    handleAllCheck() {
      if (this.isTempAllChecked) {
        this.tempCheckedKeys = [];
      } else {
        this.tempCheckedKeys = [];
        Object.values(this.nodeMap).forEach(node => {
          if (!node.hasChildren) {
            this.checkTempNodeAndAncestors(node.id);
          }
        });
      }
      Object.values(this.nodeMap).forEach(node => {
        if (node.hasChildren) {
          this.updateTempParentStatus(node.id);
        }
      });
    },

    updateTempParentStatus(parentId) {
      const parentNode = this.nodeMap[parentId];
      if (!parentNode || !parentNode.hasChildren) return;
      const childIds = parentNode.children.map(child => child.id);
      const allChildrenChecked = childIds.every(id => this.isTempOptionChecked(id));
      const hasAnyChildChecked = childIds.some(id => this.isTempOptionChecked(id) || this.isTempOptionIndeterminate(id));
      const parentIndex = this.tempCheckedKeys.indexOf(parentId);
      if (allChildrenChecked) {
        if (parentIndex === -1) this.tempCheckedKeys.push(parentId);
      } else {
        if (parentIndex > -1) this.tempCheckedKeys.splice(parentIndex, 1);
      }
      if (parentNode.parentId) {
        this.updateTempParentStatus(parentNode.parentId);
      }
    },

    updateFormalSelectedLabels() {
      this.selectedLabels = this.checkedLeafIds.map(id => {
				return this.getFullLabelPath(id);
			}).filter(Boolean);
    },

    updateFormalParentStatus(parentId) {
      const parentNode = this.nodeMap[parentId];
      if (!parentNode || !parentNode.hasChildren) return;
      const childIds = parentNode.children.map(child => child.id);
      const allChildrenChecked = childIds.every(id => this.checkedKeys.includes(id));
      const hasAnyChildChecked = childIds.some(id => this.checkedKeys.includes(id) || this.isFormalOptionIndeterminate(id));
      const parentIndex = this.checkedKeys.indexOf(parentId);
      if (allChildrenChecked) {
        if (parentIndex === -1) this.checkedKeys.push(parentId);
      } else {
        if (parentIndex > -1) this.checkedKeys.splice(parentIndex, 1);
      }
      if (parentNode.parentId) {
        this.updateFormalParentStatus(parentNode.parentId);
      }
    },

    isFormalOptionIndeterminate(id) {
      const node = this.nodeMap[id];
      if (!node || !node.hasChildren) return false;
      const allChecked = node.children.every(child => this.checkedKeys.includes(child.id));
      const anyChecked = node.children.some(child => this.checkedKeys.includes(child.id) || this.isFormalOptionIndeterminate(child.id));
      return !allChecked && anyChecked;
    },

    removeTagOutside(idx) {
      const leafId = this.checkedLeafIds[idx];
      if (!leafId) return;
      const formalIndex = this.checkedKeys.indexOf(leafId);
      if (formalIndex > -1) {
        this.checkedKeys.splice(formalIndex, 1);
      }
      this.uncheckFormalNodeRecursive(leafId);
      this.updateFormalParentStatus(this.nodeMap[leafId].parentId);
      this.updateFormalSelectedLabels();

      if (this.isPanelOpen) {
        const tempIndex = this.tempCheckedKeys.indexOf(leafId);
        if (tempIndex > -1) {
          this.tempCheckedKeys.splice(tempIndex, 1);
        }
        this.uncheckTempNodeRecursive(leafId);
        this.updateTempParentStatus(this.nodeMap[leafId].parentId);
        this.updateTempSelectedLabels();
      }

			this.$emit('confirm', {
        checkIds: this.checkedLeafIds,
        checkLabels: this.selectedLabels,
        activeNodeIds: this.activeNodeIds,
				isSelectAll: this.isTempAllChecked
      });
    },

    uncheckFormalNodeRecursive(nodeId) {
      const node = this.nodeMap[nodeId];
      if (!node) return;
      const index = this.checkedKeys.indexOf(nodeId);
      if (index > -1) {
        this.checkedKeys.splice(index, 1);
      }
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => this.uncheckFormalNodeRecursive(child.id));
      }
    },

    togglePanel() {
      this.isPanelOpen = !this.isPanelOpen;
    },

    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.closePanel();
      }
    },

    closePanel() {
      this.isPanelOpen = false;
    },

    handleOptionSelect(item, levelIndex) {
      this.activeNodeIds.splice(levelIndex);
      this.activeNodeIds.push(item.id);
      this.activeLevels.splice(levelIndex + 1);

      if (this.isShowAllCard) {
        let curr = item;
        while (true) {
          if (!curr.children || curr.children.length === 0) break;
          this.activeLevels.push(curr.children);
          const next = curr.children.find(c => c.children&&c.children.length > 0);
          if (!next) break;
          this.activeNodeIds.push(next.id);
          curr = next;
        }
      } else {
        if (item.children && item.children.length > 0) {
          this.activeLevels.push(item.children);
        }
      }

      if (this.leafRowSelect && !item.hasChildren) {
        this.handleOptionCheck(item, levelIndex);
      }
    },

    handleConfirm() {
      this.checkedKeys = [...this.tempCheckedKeys];
      this.selectedLabels = [...this.tempSelectedLabels];
      this.$emit('confirm', {
        checkIds: this.checkedLeafIds,
        checkLabels: this.selectedLabels,
        activeNodeIds: this.activeNodeIds,
				isSelectAll: this.isTempAllChecked
      });
      this.closePanel();
    },

		getFullLabelPath(nodeId) {
			const path = [];
			let currentNode = this.nodeMap[nodeId];
			while (currentNode) {
				path.unshift(currentNode.title);
				currentNode = currentNode.parentId ? this.nodeMap[currentNode.parentId] : null;
			}
			return path.join('-');
		},
  }
}
</script>

<style scoped lang="scss">
/* 容器 */
.cascade-selector {
  width: 100%;
  display: inline-block;
  position: relative;
  font-size: 14px;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* 触发按钮 */
.selector-trigger {
  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  flex-wrap: wrap;
  box-sizing: border-box;
	padding-left: 5px;
	padding-right: 5px;

  .selected-inp {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .selected-ploc {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #BFBFBF;
			line-height: 32px;
			margin-left: 7px;
			margin-right: 7px;
    }
  }
  /* 选中标签 */
  .selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1;
		padding: 5px 0px;
    .tag {
      display: inline-flex;
      align-items: center;
      padding: 5px 10px;
      border-radius: 4px;
      background: rgba(24, 144, 255, .1);
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #5E6779;
    }
    .tag-close {
      margin-left: 6px;
      cursor: pointer;
      font-size: 14px;
      color: #999;
      line-height: 1;
      img {
        width: 11px;
        height: 11px;
      }
    }
    .tag-close:hover {
      color: #ff4d4f;
    }
  }
  /* 箭头 */
  .arrow {
    font-size: 12px;
    color: #666;
    transition: transform 0.2s;
    line-height: 1;
  }
  .arrow.up {
    transform: rotate(180deg);
  }
}

/* 面板 */
.cascade-panel {
  position: absolute;
  top: calc(100% + 3px);
  left: 0;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(74,124,232,0.15);
	border-radius: 4px;
	border: 1px solid #B7DCFE;
  z-index: 1000;
  box-sizing: border-box;
	overflow: hidden;
}

/* 面板内容（分栏容器） */
.panel-content {
  display: flex;
  max-height: 300px;
  overflow: hidden;
}

/* 分栏 */
.column {
  max-height: 300px;
  overflow-y: auto;
  border-right: 1px solid rgba(182, 201, 243, 1);
  box-sizing: border-box;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.column:last-child {
  border-right: none;
}

/* 选项 */
.option {
  padding: 10px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.option:hover {
  background: #f5f7fa;
}
.option.active {
  background: rgba(24, 144, 255, .1);
  color: rgba(23, 143, 254, 1);
}

.label-text {
  display: flex;
}

.labbel-item {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #58595A;
	line-height: 20px;
}

/* 全部选择特殊样式 */
.all-select {
  border-bottom: 1px solid #f0f0f000;
  font-weight: 500;
  position: sticky;
  top: 0;
  z-index: 99;
  background: #fff;
}
.all-select:hover {
  background: #f5f7fa;
}

/* 复选框图片样式 */
.checkbox-img {
  width: 14px;
  height: 14px;
  cursor: pointer;
  display: inline-block;
  margin-right: 8px;
	margin-top: 2px;
}
.checkbox-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
	vertical-align: unset;
}

/* 面板底部按钮 */
.panel-footer {
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}
.btn {
  padding: 6px 16px;
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  border: none;
  transition: background 0.2s;
}
.btn.cancel {
  margin-right: 8px;
  width: 62px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid rgba(0,0,0,0.15);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0,0,0,0.65);
  line-height: 12px;
  text-align: center;
  font-style: normal;
}
.btn.confirm {
  background: #1890ff;
  color: #fff;
}
.btn.confirm:disabled {
  background: #8cc5ff;
  cursor: not-allowed;
}
.dean_record-cascade-selector {
	.cascade-panel {
		box-shadow: 0px 0px 10px 0px rgba(94, 103, 121, 0.2);
    border-radius: 8px;
    border: none;
		.option.active {
			background: rgba(236, 241, 252, 1);
		}
	}
	.column {
		padding: 4px;
		border-right: 1px solid #f0f0f0;
	}
	.all-select:hover {
		background: rgba(236, 241, 252, 1) !important;
	}
	.all-select {
		background: #ffffff;
	}
	.cascade-panel .option.active {
		background: unset;
	}
	.option:hover {
		background: rgba(236, 241, 252, 1) !important;
	}
	.option {
		padding-left: 8px;
		padding-right: 8px;
		border-radius: 2px;
	}
}
</style>